import {Container} from '@mantine/core'
import {createFileRoute} from '@tanstack/react-router'

import {RentalReportPage} from '../../../rental-report/rental-report-page'
import {validateRentalReportSearch} from '../../../rental-report/search'

export const Route = createFileRoute('/_app/reports/rental')({
    validateSearch: validateRentalReportSearch,
    component: RentalReportRoute,
})

function RentalReportRoute() {
    const search = Route.useSearch()

    return (
        <Container size="lg" py="xl">
            <RentalReportPage search={search} />
        </Container>
    )
}
